import { Form } from '@components/rhf/src/MUI5';
import { Box } from '@mui/material';
import Compressor from 'compressorjs';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { ActionsWrapper, ServerError, Spinner, Upload } from '.';
import {
  addDokument,
  deleteDokument,
  editDokument,
  getApplication,
  getApplicationDocuments,
  getTipoviDokumenata,
  insertEvent,
} from '../api';
import useOfficerProfile from '../hooks/useOfficerProfile';
import getCoords from '../utils/getCoords';

const ApplicationDocumentsMikra = ({ applicationId, previous, next, disabled }) => {
  
  const queryClient = useQueryClient();

  const methods = useForm({
    defaultValues: {},
    mode: 'onBlur',
  });

  const { isSubmitting } = methods.formState;

  const [files, setFiles] = useState([]);
  const [downloaded, setDownloaded] = useState(false);
  const [application, setApplication] = useState({
    brojzahtjeva: -1,
    amount: 1000,
    gracePeriod: 0,
    repaymentPeriod: 10,
    loanProductType: '',
    loanProducts: '',
    remark: '',
    loanProduct: '',
    level2: '',
    level3: '',
    level4: '',
    level5: '',
    level6: '',
    level7: '',
    recommendedLoanPurpose: '',
    loanType: '',
    payoutType: '',
    action: '',
    interestRate: '',
  });
  const { enqueueSnackbar } = useSnackbar();
  const {  officerUsername } = useOfficerProfile();
  const documents = useQuery(['applicationDocuments', applicationId], () => getApplicationDocuments(applicationId), {
    onSuccess: (res) => {
      //duboko kopiranje dokumenata
      setFiles(JSON.parse(JSON.stringify(res)));
      setDownloaded(true);
    },
    enabled: !downloaded,
  });
  const docTypes = useQuery('tipoviDokumenata', getTipoviDokumenata);

  useQuery(['loanApplication', applicationId], () => getApplication(applicationId), {
    enabled: applicationId != -1,
    onSuccess: (res) => {
      if (!application.komitent) methods.reset(res);
      setApplication(res);
    },
  });

  const { mutateAsync: mutateDeleteDocument } = useMutation(deleteDokument, {
    onSuccess: () => {
      enqueueSnackbar('Uspješno spremljene promjene.', {
        variant: 'success',
        autoHideDuration: 3000,
      });
    },
    onError: (error) => {
      enqueueSnackbar('Greška prilikom brisanja dokumenta', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    },
  });
  const { mutateAsync: mutateEditDocument } = useMutation(editDokument, {
    onSuccess: () => {
      enqueueSnackbar('Uspješno spremljene promjene.', {
        variant: 'success',
        autoHideDuration: 3000,
      });
    },
    onError: (error) => {
      enqueueSnackbar('Greška prilikom uređivanja dokumenta', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    },
  });
  const { mutateAsync: mutateAddDocument } = useMutation(addDokument, {
    onSuccess: () => {
      enqueueSnackbar('Uspješno ste dodali dokument.', {
        variant: 'success',
        autoHideDuration: 3000,
      });
    },
    onError: (error) => {
      enqueueSnackbar('Greška prilikom unosa dokumenta', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    },
  });
  const newDocument = async (document) => {
    try {
    const formData = new FormData();

    formData.append('name', document.name);
    formData.append('path', document.path);
    formData.append('doctype', document.docType);
    formData.append('size', document.size);

    await new Promise((resolve, reject) => {
      new Compressor(document, {
        quality: 0.8,
        convertSize: 1000000,
        maxWidth: 950,
        maxHeight: 950,
        success(result) {
          formData.append('file', result, document.name);
          resolve();
        },
        error(error) {
          console.error('Compression error:', error);
          formData.append('file', document, document.name);
          resolve();
        },
      });
    });

    formData.append('brojzahtjeva', applicationId);
    formData.append('createdBy', officerUsername);
    formData.append('opis', !!document.opis ? document.opis : null);
    formData.append('clientId', null);

    await getCoords().then((coords) => {
      insertEvent({
        lat: coords ? coords.latitude : null,
        lng: coords ? coords.longitude : null,
        alt: coords ? coords.altitude : null,
        docId: applicationId ? parseInt(applicationId) : -1,
        docType: 5, // 5 - DOKUMENT ZAHTJEV
        emp: officerUsername ? Number(officerUsername) :null,
      });
    });

    return mutateAddDocument(formData);
  } catch (e) {console.log('error---', e)};
  };
  const handleSubmit = async () => {
    //validacija tipova dokumenata
    let tipGreska = false;
    if (files) {
      for (let i = 0; i < files.length; i++) {
        if (files[i].docType == -1) tipGreska = true;
      }
    }
    if (tipGreska) {
      enqueueSnackbar('Izaberite tip dokumenata', {
        variant: 'error',
        autoHideDuration: 3000,
      });
      return;
    }
    let promises = [];
    //brisanje starih fajlova koji su obrisani (mutate)
    if (documents.data) {
      for (let i = 0; i < documents.data.length; i++) {
        let notDeleted = false;
        if (files) {
          for (let j = 0; j < files.length; j++) {
            //provjeriti na osnovu kojeg parametra se porede
            if (documents.data[i].id == files[j].id) {
              notDeleted = true;
              //promijeni tip dokumenata kod starih kojima je promijenjen
              if (documents.data[i].docType != files[j].docType || (documents.data[i].opis != files[j].opis)) 
                promises.push(mutateEditDocument(files[j]));
            }
          }
        }
        if (!notDeleted) promises.push(mutateDeleteDocument(documents.data[i].id));
      }
    }

    //nove dokumente spremi isto kao u loanapplication
    if (files) {
      for (let i = 0; i < files.length; i++) {
        let added = true;
        if (documents.data) {
          for (let j = 0; j < documents.data.length; j++) {
            //provjeriti na osnovu kojeg parametra se porede
            if (files[i].id == documents.data[j].id) {
              added = false;
            }
          }
        }
        if (added) promises.push(await newDocument(files[i]));
      }
    }
    queryClient.invalidateQueries(['applicationDocuments', applicationId]);
    Promise.all(promises).then(() => next());
    return Promise.all(promises);
  };
  const handleChange = (values) => {
    setFiles(values);
  };

  let actionLabel;
    actionLabel = 'Spremi dokumente';
  return (
    <Box sx={{ overflowY: 'auto' }}>
      {(documents.error || docTypes.error) && <ServerError error={documents.error || docTypes.error} />}
      {(documents.isLoading || docTypes.isLoading) && <Spinner />}
      {!documents.isLoading && !documents.error && docTypes.data && (
        <Box>
          <Box mb={4} />
          <Form methods={methods} onSubmit={disabled ? next : handleSubmit}>
            <Upload handleChange={handleChange} docTypes={docTypes.data} defaultFiles={files} disabled={disabled} disableDelete={application?.status != 3} />
            <Box height="16px" />
            <ActionsWrapper previous={previous} isSubmitting={isSubmitting} label={actionLabel} />
          </Form>
        </Box>
      )}
    </Box>
  );
};

export default ApplicationDocumentsMikra;
